/** Apply the shared SEO definitions to both public routes and blog responses. */
import {
  blogUrl,
  buildJsonLd,
  buildMetaTags,
  buildNotFoundMetaTags,
  DEFAULT_SITE_URL,
} from '../utils/blogSeo.js';
import { applyPageHead } from '../utils/pageHead.js';
import {
  buildPublicPageMetaTags,
  normalizePublicPath,
} from '../utils/publicPageSeo.js';

// Keep the origin chosen by the build throughout navigation. On the neutral
// fallback (or in development), use the current origin.
const siteUrl =
  typeof window === 'undefined'
    ? DEFAULT_SITE_URL
    : new URL(
        document.querySelector('link[rel="canonical"]')?.href ||
          window.location.href
      ).origin;

export const applyBlogArticleSeo = (post) => {
  applyPageHead(buildMetaTags(post, siteUrl), buildJsonLd(post, siteUrl));
};

export const applyBlogListingSeo = () => {
  applyPageHead(buildMetaTags(null, siteUrl), buildJsonLd(null, siteUrl));
};

export const applyBlogNotFoundSeo = () => {
  applyPageHead(buildNotFoundMetaTags());
};

export const applyRouteSeo = (to, from) => {
  if (to.name === 'blog-detail') {
    // Query/hash navigation should retain metadata already fetched for this post.
    if (
      normalizePublicPath(to.path) === normalizePublicPath(from.path) &&
      from.name === to.name
    )
      return;
    const url = blogUrl(to.params.slug, siteUrl);
    // A direct visit already has the complete article metadata in its HTML.
    if (
      !from.matched.length &&
      document.querySelector('link[rel="canonical"]')?.href === url
    )
      return;
    applyPageHead(
      buildMetaTags(
        { slug: to.params.slug, title: 'Article - sortmyprep' },
        siteUrl
      )
    );
    return;
  }
  if (normalizePublicPath(to.path) === '/blogs') {
    applyBlogListingSeo();
    return;
  }
  const tags = buildPublicPageMetaTags(to.path, siteUrl);
  applyPageHead(
    tags || {
      title: to.meta?.title || 'sortmyprep',
      meta: [{ name: 'robots', content: 'noindex, follow' }],
      link: [],
    }
  );
};
